import React from 'react'
import { ViewIcon, EditIcon, DeleteIcon } from '../Icons'

const ActionButtons = ({ onView, onEdit, onDelete }) => {
  return (
    <div className="flex justify-center items-center gap-1.5">
      {onView && (
        <button
          onClick={onView}
          className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors"
          aria-label="View details"
        >
          <span className="text-[#535862]">
            <ViewIcon />
          </span>
        </button>
      )}
      <button
        onClick={onEdit}
        className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors"
        aria-label="Edit"
      >
        <span className="text-[#535862]">
          <EditIcon />
        </span>
      </button>
      <button
        onClick={onDelete}
        className="border bg-[rgba(233,0,4,0.10)] p-2 rounded-[10px] border-[rgba(233,0,4,0.20)] hover:bg-[rgba(233,0,4,0.15)] transition-colors"
        aria-label="Delete"
      >
        <DeleteIcon />
      </button>
    </div>
  )
}

export default ActionButtons
